import React from 'react';
import {Grid} from '@mui/material';
import PageWrapper from '../utils/PageWrapper';
import IconLinkList from '../ui/IconLinkList';
import {groupOrderSubSites} from '../../config/routeItems';
import OrderManager from '../contactPersons/OrderManager';

function Orders() {

    return (
        <PageWrapper siteTitle={'customerportal.navigation.orders'} switchClient={true}>
            <Grid container
                  columnSpacing={5}
                  rowSpacing={2.5}
            >
                <Grid item
                      xs={12}
                      lg={8}
                >
                    <IconLinkList items={groupOrderSubSites}/>
                </Grid>
                <Grid item
                      xs={12}
                      lg={4}
                      sx={{
                          position: 'relative',
                      }}
                >
                    <OrderManager/>
                </Grid>

            </Grid>
        </PageWrapper>
    );
}

export default Orders;
